/*
 *   File : file-picker.js
 *   Author : https://evoqins.com
 *   Description : File picker component
 *   Integrations : NA
 *    Version : 1.0.0
*/

import { useEffect, useRef, useState } from 'react';
import { _checkFileSize } from '../../Helper';
import { toast } from 'react-toastify';

const FilePicker = (props) => {

    const [file, setFile] = useState(props.file || null);
    const [isInputFocused, setIsInputFocused] = useState(props.autoFocus || false);
    const [floatingLabel, setFloatingLabel] = useState(props.autoFocus || false);

    useEffect(() => {
        window.addEventListener('click', _handleBlur);
        // cleanup to avoid multiple listeners
        return () => {
            window.removeEventListener("click", _handleBlur);
        };
    }, [file, isInputFocused]);

    useEffect(() => {
        if (props.file) {
            setFloatingLabel(true);
            setFile(props.file);
        }
    }, [props.file]);

    //handle upload 
    const _handleUpload = () => {

        if (file == null) {
            if (floatingLabel) {
                if (document.getElementById(props.id)) {
                    document.getElementById(props.id)?.click();
                    setIsInputFocused(true);
                }
            } else {
                setFloatingLabel(true);
                setIsInputFocused(true);
            }
        }
    };

    const _handleSelectFile = (file) => {
        const is_file_size_valid = _checkFileSize(file.target.files[0].size);
        if (is_file_size_valid) {
            // setFile(file.target.files[0]);
            props.selectFile(file);
        } else {
            toast.dismiss();
            toast.error("Maximum file size should be 5mb only");
        }
    };

    const _handleFocus = (e) => {
        if (isInputFocused === false) {
            setIsInputFocused(true);
            setFloatingLabel(true);
        };
    };

    const _handleBlur = (event) => {
        if (event.target.closest(`#file-upload-${props.id}`) === null && isInputFocused === true) {
            if (file === null) {
                setFloatingLabel(false);
                setIsInputFocused(false);
            } else {
                setIsInputFocused(false);
            }
        }
    };

    const _handleRemoveFile = (event) => {
        setFile(null);
        props.selectFile(null);
        event.preventDefault();
        event.stopPropagation();
    }

    return (
        <div id={`file-upload-${props.id}`} className={`${props.error && 'border-red-1px '}  ${isInputFocused ? "e-border-1px-egyptian-blue" : "e-border-1px-sonic-silver"}  cursor-pointer padding-18px-tb padding-12px-tb-res padding-12px-lr e-border-radius-10 position-relative`}
            onClick={_handleUpload} >

            {props.label &&
                <label className={`${props.labelStyle} ${floatingLabel ? "focused pe-none" : ""} floating-label  e-text-dark-charcoal e-font-weight-400 e-alt-font-poppins line-height-24px e-font-12-res e-font-14 z-3`} onClick={_handleFocus}>
                    {props.label}
                    {props.require && <span className='e-text-sunset-orange'>*</span>}
                </label>
            }

            <input id={props.id}
                ref={props.ref}
                type={props.type}
                key={props.key}
                accept={props.accept}
                style={{ display: 'none' }}
                onChange={_handleSelectFile}
                className='invisible'
                onClick={(e) => {
                    e.target.value = ""
                }} />


            {
                file ?
                    <div className={`d-flex align-items-center gap-2`}>

                        <img src={typeof file === "string" ? file : URL.createObjectURL(file)}
                            draggable={false}
                            width={24}
                            height={20}
                            className='cursor-pointer e-border-radius-4'
                            alt='uploaded file' />
                        <span className="e-font-10 e-alt-font-poppins e-font-weight-500 e-text-charleston-green" style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }}>
                            {file.name}
                        </span>
                        <img src={require("../../Assets/Images/KYC/selected-close.svg").default}
                            draggable={false}
                            width={16}
                            height={16}
                            className='cursor-pointer'
                            alt='delete'
                            onClick={_handleRemoveFile} />
                    </div>
                    :
                    <div className={`${floatingLabel ? "opacity-100" : "opacity-0"} d-flex align-items-center gap-12px`}>
                        <img src={require("../../Assets/Images/Onboarding/file-upload.svg").default}
                            width={20}
                            height={20}
                            draggable={false}
                            alt='upload icon' />
                        {
                            props.isFileUploading ?
                                <p className=' e-text-egyptian-blue  e-font-10 e-alt-font-poppins e-font-weight-600 mb-0'>
                                    Uploading...
                                </p>
                                :
                                <p className='d-flex gap-1  align-items-center mb-0 e-text-egyptian-blue  e-font-10 e-alt-font-poppins e-font-weight-600'>
                                    <span>
                                        Click to upload
                                    </span>
                                    <span className='e-font-weight-400 e-font-8 e-text-quick-silver'>JPG, JPEG, PNG less than 5MB</span>
                                </p>
                        }

                    </div>
            }

            {/* Error text */}
            {
                props.error !== "" &&
                <p className={`${props.errorMsg === "" ? "opacity-0" : "opacity-100"} mb-0 e-error-message e-font-12 line-height-12px position-absolute  top-100 start-0 padding-2-top`}>
                    {props.error}
                </p>
            }
        </div>
    )
}

export default FilePicker;